import { getFileExtension, getVimeoId, getYoutubeId } from './video-utils';

interface VideoSettings {
    url: string;
    hasPreviewImg?: boolean;
}

interface VideoProps {
    el: HTMLElement;
    props: VideoSettings;
}

const PLAY_BTN_CLASS = 'video-button';
const VIDEO_WRAPPER_CLASS = 'video-inner';
const VIDEO_CONTAINER_CLASS = 'video-container';
const VIDEO_CLASS = 'video-video';

export const getVideoData = (url: string, hasPreviewImg?: boolean): { videoType: string; videoEl: string } => {
    let videoType;
    let videoEl;

    // FROM YOUTUBE
    if ((/^.*(youtube.com\/|youtu.be\/).*$/).test(url)) {
        videoType = 'youtube';
        const videoId = getYoutubeId(url);
        videoEl = `
        <iframe
            src="https://www.youtube.com/embed/${videoId}?rel=0&showinfo=0&color=white${hasPreviewImg ? '&autoplay=1' : ''}"
            class="${VIDEO_CLASS}"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            webkitallowfullscreen
            mozallowfullscreen
            allowfullscreen
        >
        </iframe>`;

        // FROM VIMEO
    } else if (url.includes('vimeo.com/')) {
        videoType = 'vimeo';
        const videoId = getVimeoId(url);
        videoEl = `
        <iframe
            class="${VIDEO_CLASS}"
            style="position:absolute;top:0;left:0;width:100%;height:100%;"
            src="https://player.vimeo.com/video/${videoId}${hasPreviewImg ? '?autoplay=1' : ''}"
            frameborder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            webkitAllowFullScreen
            mozallowfullscreen
            allowFullScreen
        >
        </iframe>`;

        // FROM UPLOAD
    } else {
        videoType = 'upload';
        const fileExt = getFileExtension(url);
        videoEl = `
        <video class="${VIDEO_CLASS}" controls width="640" height="360" ${hasPreviewImg ? 'autoplay' : ''}>
            <source src="${url}" type="video/${fileExt}">
            Sorry, your browser doesn't support embedded videos.
        </video>
        `;
    }

    return {
        videoType,
        videoEl: `
        <div class="${VIDEO_CONTAINER_CLASS}">
            ${videoEl}
        </div>
        `,
    };
};

const Video = ({ el, props }: VideoProps): void => {
    const { url, hasPreviewImg = false } = props;

    if (!url) {
        return;
    }

    const videoData = getVideoData(url, hasPreviewImg);
    const videoContainer = el.querySelector(`.${VIDEO_WRAPPER_CLASS}`);

    const showVideo = (): void => {
        const isVideoExist = el.querySelector(`.${VIDEO_CLASS}`);

        if (!isVideoExist && videoContainer) {
            videoContainer.insertAdjacentHTML('afterbegin', videoData.videoEl);
        }

        el.classList.add('show-video');
    };

    if (hasPreviewImg) {
        const playBtn = el.querySelector(`.${PLAY_BTN_CLASS}`) as HTMLButtonElement;

        playBtn?.addEventListener('click', () => {
            showVideo();
        });
    } else {
        showVideo();
    }
};

export default Video;
